import {
  EventEmitterMethods_default
} from "./chunk-D5JVWJXO.js";
import {
  init_shim
} from "./chunk-XJTZ422K.js";

// node_modules/phaser3-rex-plugins/plugins/utils/componentbase/ComponentBase.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/utils/system/GetSceneObject.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/utils/system/IsSceneObject.js
init_shim();
var SceneClass = Phaser.Scene;
var IsSceneObject = function(object) {
  return object instanceof SceneClass;
};
var IsSceneObject_default = IsSceneObject;

// node_modules/phaser3-rex-plugins/plugins/utils/system/GetSceneObject.js
var GetSceneObject = function(object) {
  if (object == null || typeof object !== "object") {
    return null;
  } else if (IsSceneObject_default(object)) {
    return object;
  } else if (object.scene && IsSceneObject_default(object.scene)) {
    return object.scene;
  } else if (object.parent && object.parent.scene && IsSceneObject_default(object.parent.scene)) {
    return object.parent.scene;
  } else {
    return null;
  }
};
var GetSceneObject_default = GetSceneObject;

// node_modules/phaser3-rex-plugins/plugins/utils/system/GetGame.js
init_shim();

// node_modules/phaser3-rex-plugins/plugins/utils/system/IsGame.js
init_shim();
var GameClass = Phaser.Game;
var IsGame = function(object) {
  return object instanceof GameClass;
};
var IsGame_default = IsGame;

// node_modules/phaser3-rex-plugins/plugins/utils/system/GetGame.js
var GetGame = function(object) {
  if (object == null || typeof object !== "object") {
    return null;
  } else if (IsGame_default(object)) {
    return object;
  } else if (IsGame_default(object.game)) {
    return object.game;
  } else if (IsSceneObject_default(object)) {
    return object.sys.game;
  } else if (IsSceneObject_default(object.scene)) {
    return object.scene.sys.game;
  }
};
var GetGame_default = GetGame;

// node_modules/phaser3-rex-plugins/plugins/utils/componentbase/ComponentBase.js
var GetValue = Phaser.Utils.Objects.GetValue;
var ComponentBase = class {
  constructor(parent, config) {
    this.setParent(parent);
    this.isShutdown = false;
    this.setEventEmitter(GetValue(config, "eventEmitter", true));
    if (this.parent) {
      if (this.parent === this.scene) {
        this.scene.sys.events.once("shutdown", this.onEnvDestroy, this);
      } else if (this.parent === this.game) {
        this.game.events.once("shutdown", this.onEnvDestroy, this);
      } else if (this.parent.once) {
        this.parent.once("destroy", this.onParentDestroy, this);
      }
    }
  }
  shutdown(fromScene) {
    if (this.isShutdown) {
      return;
    }
    if (this.parent) {
      if (this.parent === this.scene) {
        this.scene.sys.events.off("shutdown", this.onEnvDestroy, this);
      } else if (this.parent === this.game) {
        this.game.events.off("shutdown", this.onEnvDestroy, this);
      } else if (this.parent.once) {
        this.parent.off("destroy", this.onParentDestroy, this);
      }
    }
    this.destroyEventEmitter();
    this.parent = void 0;
    this.scene = void 0;
    this.game = void 0;
    this.isShutdown = true;
  }
  destroy(fromScene) {
    this.shutdown(fromScene);
  }
  onEnvDestroy() {
    this.destroy(true);
  }
  onParentDestroy(parent, fromScene) {
    this.destroy(fromScene);
  }
  setParent(parent) {
    this.parent = parent;
    this.scene = GetSceneObject_default(parent);
    this.game = GetGame_default(parent);
    return this;
  }
};
Object.assign(
  ComponentBase.prototype,
  EventEmitterMethods_default
);
var ComponentBase_default = ComponentBase;

export {
  GetSceneObject_default,
  GetGame_default,
  ComponentBase_default
};
